module.exports = __webpack_public_path__ + "static/img/banner_header_example.025e8bc3.jpg";